import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// TrashIcon.tsx -- corner-fixed drop target for soft-delete.
//
// Per design \u00a76.1 the trash sits in the lower-left, always visible. Drop an
// in-app file or folder onto it = soft-delete (CatalogTransfer to project's
// trashFolderId). The badge shows the trash folder's item count.
//
// Click opens the trash folder. Right-click could expose "Empty trash" but
// that's gated to role: full and only relevant when count > 0.
import { useCallback, useState } from 'react';
import { useDesktop } from '../../hooks/useDesktop.js';
export function TrashIcon({ trashCount, onClick, onDropEntry }) {
    const { drag, dragOverTarget, setDragOverTarget } = useDesktop();
    const [over, setOver] = useState(false);
    const onDragEnter = useCallback((e) => {
        if (drag?.source !== 'in-app')
            return;
        e.preventDefault();
        setOver(true);
        setDragOverTarget('__trash__');
    }, [drag, setDragOverTarget]);
    const onDragOver = useCallback((e) => {
        if (drag?.source !== 'in-app')
            return;
        e.preventDefault();
        e.dataTransfer.dropEffect = 'move';
    }, [drag]);
    const onDragLeave = useCallback(() => {
        setOver(false);
        if (dragOverTarget === '__trash__')
            setDragOverTarget(null);
    }, [dragOverTarget, setDragOverTarget]);
    const onDrop = useCallback(async (e) => {
        e.preventDefault();
        setOver(false);
        setDragOverTarget(null);
        const raw = e.dataTransfer.getData('application/x-fdn-entry');
        if (!raw)
            return;
        try {
            const entry = JSON.parse(raw);
            if (entry.itemId) {
                await onDropEntry(entry.itemId);
            }
        }
        catch {
            // bad payload; ignore
        }
    }, [onDropEntry, setDragOverTarget]);
    return (_jsxs("button", { type: "button", className: `trash-icon ${over ? 'over' : ''} ${trashCount > 0 ? 'has-items' : ''}`, onClick: onClick, onDragEnter: onDragEnter, onDragOver: onDragOver, onDragLeave: onDragLeave, onDrop: onDrop, title: trashCount > 0 ? `Trash (${trashCount} item${trashCount === 1 ? '' : 's'})` : 'Trash (empty)', children: [_jsx("span", { className: "trash-glyph", "aria-hidden": true, children: '\uD83D\uDDD1\uFE0F' }), trashCount > 0 && _jsx("span", { className: "trash-badge", children: trashCount })] }));
}
